import { useEffect } from 'react';
import { runDevAutoImpersonate } from './devAutoImpersonate';

/**
 * Inicio de sesión automático para desarrollo, igual que en
 * sporttia-competitions: al arrancar entra con un administrador e impersona un
 * centro deportivo, para no tener que escribir credenciales en cada recarga.
 *
 * Sólo se ejecuta con el servidor de desarrollo (`import.meta.env.DEV`) y sólo
 * si están las tres variables en el `.env`. En cualquier build de producción
 * Vite sustituye esa condición por `false` y el código se cae del bundle, así
 * que ni las llamadas ni las variables llegan a PRE ni a PRO.
 *
 * Variables necesarias en `.env`:
 *   VITE_DEV_ADMIN_LOGIN      usuario administrador (es quien puede impersonar)
 *   VITE_DEV_ADMIN_PASSWORD   su contraseña
 *   VITE_DEV_IMPERSONATE_ID   id del centro deportivo al que entrar
 *
 * La petición tiene que salir de la pestaña de localhost para que la API deje
 * la cookie a nombre de ese origen; por eso vive en el navegador y no en un
 * script de Node.
 *
 * Se puede llamar sin condiciones: el efecto se auto-bloquea, así que no rompe
 * las reglas de los hooks.
 */
export function useDevAutoImpersonate(): void {
    useEffect(() => {
        if (!import.meta.env.DEV) return;

        void runDevAutoImpersonate(
            {
                adminLogin: import.meta.env.VITE_DEV_ADMIN_LOGIN ?? '',
                adminPassword: import.meta.env.VITE_DEV_ADMIN_PASSWORD ?? '',
                impersonateId: import.meta.env.VITE_DEV_IMPERSONATE_ID ?? '',
                apiUrl: window.runtimeConfig?.apiEnv?.url ?? '',
            },
            () => window.location.reload(),
        );
    }, []);
}
